























































































import { Component, Prop } from "vue-property-decorator";
import { WorkshopModel } from "@/core/models";
import { ConfirmDialogCpt, GridTableCpt } from "@/core/components";
import { RevStatusCpt, FollowUpStatusCpt } from "./status-badges";

import AppVue from "@/AppVue.vue";

@Component({
  components: {
    ConfirmDialogCpt,
    RevStatusCpt,
    FollowUpStatusCpt,
    GridTableCpt,
  },
})
export default class WorkshopDetailClientsGridCpt extends AppVue {
  @Prop() model: WorkshopModel;
  @Prop({ default: false }) loading: boolean;

  search = "";
  columns = [
    { label: "Client name", prop: "name", slot: "name", width: "150px", sortable: true },
    { label: "Client Sector", prop: "companySectorName", slot: "companySectorName", width: "250px", sortable: true },
    { label: "Participants", prop: "participants", slot: "participants", width: "400px", sortable: false },
    { label: "Rev. Status", prop: "revStatusName", slot: "revStatusName", width: "135px", sortable: true },
    {
      label: "Follow-Up Status",
      prop: "followUpStatusName",
      slot: "followUpStatusName",
      width: "155px",
      sortable: true,
    },
    { label: "Actions", prop: "actions", slot: "actions", width: "235px", sortable: false },
  ];
}
